<template>
    <div>
        <div class="calendar-graph-title"> {{ this.year }} Working Days / Holidays </div>
        <apexcharts width="100%" height="200px" type="bar" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: 'CalendarGraph',
    components: {
        apexcharts: VueApexCharts
    },
    props: ['currYearHolidayList', 'currYearCalendarMatrix', 'currYear']
    ,
    created() {
    },
    watch: {
        //Calendar에서의 current year값
        currYear(data) {
            this.year = data;
        },
        //현재 연도의 공휴일 정보
        currYearHolidayList(data) {
            this.holidayList = data;
        },
        //현재 연도의 달력 정보 From ChatterMainCalendar.vue
        currYearCalendarMatrix(data) {
            this.initGraph(data);
        }
    },
    data() {
        return {
            //props 저장할 값(현재 연도의 모든 휴일 정보(month 구분 x))
            holidayList: [],
            calendarMatrix: [],
            //현재 연도의 매달 휴일 날짜 정보
            totalHolidaysDateList: [],
            //현재 연도의 매달 휴일 개수
            totalHolidaysNum: [],
            //현재 연도의 매달 working days 개수
            totalWorkingDaysNum: [],
            //현재 연도
            year: new Date().getFullYear(),
            //매달의 총 day 개수
            totaldaysNum: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    stacked: true,
                    //export button 삭제
                    toolbar: {
                        show: false,
                    },
                },
                legend: {
                    markers: {
                        radius: 50,
                    }
                },
                xaxis: {
                    type: 'categories',
                    categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                },
                yaxis: {
                    max: 35,
                    tickAmount:5,
                },
                colors: ['#176BA0', '#1BD4D4']
            },
            series: [
                {
                    name: 'Working Days',
                    data: [],
                },
                {
                    name: 'Holidays',
                    data: []
                }
            ]
        }
    },
    methods: {
        initGraph(data) {
            this.calendarMatrix = data;
            this.totalHolidaysDateList = [];
            this.totalHolidaysNum = [];
            this.totalWorkingDaysNum = [];
            this.totaldaysNum = [];
            /* 해당 연도의 달력 탐색*/
            //Holidays
            //주말 추가
            for (var month = 0; month < 12; month++) {
                var monthHolidayDateList = new Set();
                var total = 0;
                for (var week = 0; week < this.calendarMatrix[month].length; week++) {
                    //1000이상의 값: 이전달 또는 다음달 날짜
                    //일요일(idx==0)
                    if (this.calendarMatrix[month][week][0] < 1000) {
                        monthHolidayDateList.add(this.year + '-' + String(month + 1).padStart(2, '0') + '-' + String(this.calendarMatrix[month][week][0]).padStart(2, '0'));
                    }
                    //토요일(idx==6)
                    if (this.calendarMatrix[month][week][6] < 1000) {
                        monthHolidayDateList.add(this.year + '-' + String(month + 1).padStart(2, '0') + '-' + String(this.calendarMatrix[month][week][6]).padStart(2, '0'));
                    }
                }
                this.totalHolidaysDateList.push(monthHolidayDateList);
                total = Math.max(...this.calendarMatrix[month][week - 1].filter(val => val < 1000));
                //각 달마다의 days 개수
                this.totaldaysNum.push(total);
            }

            //공휴일 개수 추가
            for (var i = 0; i < this.holidayList.length; i++) {
                var month = this.holidayList[i].holidayDate.slice(5, 7);
                this.totalHolidaysDateList[month - 1].add(this.holidayList[i].holidayDate);
            }
            //매달 총 Holiday 개수 계산 => series의 Holiday 데이터
            for (var month = 0; month < 12; month++) {
                this.totalHolidaysNum.push(this.totalHolidaysDateList[month].size);
            }
            for (var i = 0; i < 12; i++) {
                this.totalWorkingDaysNum[i] = this.totaldaysNum[i] - this.totalHolidaysNum[i];
            }
            //graph에 데이터 바인딩
            this.series = [
                {
                    name: 'Working Days',
                    data: this.totalWorkingDaysNum
                },
                {
                    name: 'Holidays',
                    data: this.totalHolidaysNum
                }
            ];
        }
    }
}
</script>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.calendar-graph-title {
    padding: 1.1rem 0;
    color: #2E2E38;
    font-family: 'NanumGothic';
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
}
</style>